import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormControlErrorMessageModule } from '@portal-core/forms/components/form-control-error-message/form-control-error-message.module';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { TaskBoardSettingsFormComponent } from './task-board-settings-form.component';

@NgModule({
  imports: [
    McColorModule,
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    ReactiveFormsModule,
    LoaderModule,
    ErrorsExpansionPanelModule,
    FormControlErrorMessageModule
  ],
  declarations: [
    TaskBoardSettingsFormComponent
  ],
  exports: [
    TaskBoardSettingsFormComponent
  ]
})
export class TaskBoardSettingsFormModule { }
